import "./PagerAmount.scss";

import React from 'react';
import { React as Selectivity } from 'selectivity/react';

export default function PagerAmount(props) {
  return <div className="pager-amount">
    Oldalanként
    <Selectivity
      showSearchInputInDropdown={false}
      className="pager-amount__select"
      allowClear={false}
      value={props.perPage}
      items={[
        {id: 10, text: '10'},
        {id: 25, text: '25'},
        {id: 50, text: '50'},
        {id: 100, text: '100'},
        {id: 250, text: '250'}
      ]}
      onChange={props.onChange}
    />
    találat
  </div>
};